import { Shirt, Users } from "lucide-react";

interface Props {
  stats: { kits: number; forSale: number; collection: number; collectors: number; clubs: number };
  loading?: boolean;
}

function StatValue({ value, loading }: { value: number; loading?: boolean }) {
  if (loading) {
    return <div className="mx-auto h-9 w-16 animate-pulse rounded-md bg-muted md:h-10 md:w-20" />;
  }
  return <p className="scoreboard text-3xl md:text-4xl text-foreground">{value}</p>;
}

export default function StatsBar({ stats, loading }: Props) {
  return (
    <section className="bg-secondary">
      <div className="container py-8">
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <div className="flex items-center justify-center gap-2 text-muted-foreground mb-2">
              <Shirt className="h-5 w-5" />
            </div>
            <StatValue value={stats.collection} loading={loading} />
            <p className="mt-1 text-xs md:text-sm font-medium text-muted-foreground">w kolekcji</p>
          </div>
          <div>
            <div className="flex items-center justify-center gap-2 text-muted-foreground mb-2">
              <Shirt className="h-5 w-5" />
            </div>
            <StatValue value={stats.forSale} loading={loading} />
            <p className="mt-1 text-xs md:text-sm font-medium text-muted-foreground">na sprzedaż</p>
          </div>
          <div>
            <div className="flex items-center justify-center gap-2 text-muted-foreground mb-2">
              <Users className="h-5 w-5" />
            </div>
            <StatValue value={stats.collectors} loading={loading} />
            <p className="mt-1 text-xs md:text-sm font-medium text-muted-foreground">kolekcjonerów</p>
          </div>
        </div>
      </div>
    </section>
  );
}
